export const NETWORKS_CAPTIONS = { INSTAGRAM: 'instagram_caption', FACEBOOK: 'facebook_caption', GOOGLE: 'google_localpost_summary', LINKEDIN: 'linkedin_commentary' }
